module.exports = __webpack_public_path__ + "static/media/user.a48aca27.png";